<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Form - Revision CLOSED Sales Order
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row>
                <b-col lg="8">
                    <b-input-group>
                        <b-input-group-prepend><label>Revision Date</label></b-input-group-prepend>
                        <b-form-input v-model="model.revisiondate" type="date" :state="!$v.model.revisiondate.$error" class="mr-2"></b-form-input>                                        
                        <b-input-group-prepend><span class="input-group-text" style="font-size:smaller !important;" >Revisi pada SALES ORDER yg seharusnya sudah delivered/closed</span></b-input-group-prepend>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>Order Number</label></b-input-group-prepend>
                        <b-form-input v-model="model.nomor" readonly v-b-tooltip.hover title="Sales order seharusnya sudah invoiced/closed"></b-form-input>
                        <b-input-group-append>
                        <b-btn variant="primary" text="Button" @click="lkuSoShow=true" v-if="(!(model.salesHdrKey))" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                        <b-input-group-prepend><span class="p-2">&nbsp;&nbsp; Order Date</span></b-input-group-prepend>
                        <b-form-input v-model="model.OrderDate" type="date" :state="!$v.model.OrderDate.$error"></b-form-input>                                        
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Customer/Agency</label></b-input-group-prepend>
                        <b-form-input placeholder="Pilih Biro Iklan" v-model="model.custinfo" :state="$v.model.customer_id.$dirty ? !$v.model.customer_id.$error : null" readonly></b-form-input>
                        <b-input-group-append>
                            <b-btn  text="Button" @click="lkuCustomerShow=true" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                        </b-input-group-append>
                        <b-input-group-prepend><span class="input-group-text">Advertiser</span></b-input-group-prepend>
                        <b-form-input placeholder="Masukkan Advertiser" v-model="model.Advertiser" :state="$v.model.Advertiser.$dirty ? !$v.model.Advertiser.$error : null"></b-form-input>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>REVISION Note</label></b-input-group-prepend>
                        <b-form-input v-model="model.revisionnote" max="250" :state="!$v.model.revisionnote.$error"></b-form-input>
                    </b-input-group>

                </b-col>
                <b-col md="4">
                    <b-input-group>
                        <b-input-group-prepend><label>Sales Ex.</label></b-input-group-prepend>
                        <b-form-input v-model="model.SalesEx"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuSalesShow=true" variant="primary"><i class="fa fa-search"></i></b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>Campaign</label></b-input-group-prepend>
                        <b-form-input v-model="model.campaign" ></b-form-input>
                        <b-input-group-append>
                        <b-btn variant="primary" @click="lkuSalesCamapignShow=true"> <i class="fa fa-search"></i></b-btn>
                        </b-input-group-append>
                    </b-input-group>

                </b-col>
            </b-row>
            <b-card no-body class="mb-1">
                <b-table
                    class="mb-0"
                    ref="tblOrderLines"
                    outlined
                    striped hover small
                    style="font-size:smaller;"
                    :items="ordLines.items"
                    :fields="ordLines.fields"
                    :current-page="ordLines.page"
                    :per-page="ordLines.limit"
                    show-empty
                    >
                    <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                    </template>
                    <template v-slot:cell(itemname)="data">
                        {{data.item.itemname}} <span v-if="(data.item.remark)"> | {{data.item.remark}}</span>
                    </template>
                    <template v-slot:cell(qtyOrder)="data">
                        {{data.item.qtyOrder}} {{data.item.unitsize}}
                    </template>
                    <template v-slot:cell(priceOrder)="data">
                        {{data.item.priceOrder|numFormat}}
                    </template>
                    <template v-slot:cell(grossOrder)="data">
                        {{data.item.grossOrder|numFormat}}
                    </template>
                    <template v-slot:cell(discOrder)="data">
                        {{data.item.discOrder|numFormat}}
                    </template>
                    <template v-slot:cell(nettOrder)="data">
                        {{data.item.nettOrder|numFormat}}
                    </template>
                    <template v-slot:cell(nettSales)="data">
                        {{data.item.nettSales|numFormat}}
                    </template>
                    <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editOrderLines(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i> Edit
                        </a>
                        <!-- |
                        <a href="javascript:void(0)" class="text-danger" @click="delOrderLines(data.index)">
                            <i class="fa fa-trash"></i>
                        </a> -->
                        </div>
                    </template>
                    <template v-slot:row-details="row">
                        <b-card class="row-details-form">
                            <b-row  align-h="center">
                                <b-col lg="7" >
                                    <b-row no-gutters>
                                        <b-col md="8">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Sales Item</label></b-input-group-prepend>
                                                <b-form-input readonly v-model="ordLinesObj.itemname" @keyup.13.native="lkuItemShow=true" :state="!$v.ordLinesObj.itemno.$error"></b-form-input>
                                                <b-input-group-append>
                                                <b-btn text="Button" @click="lkuItemShow=true">
                                                    <i class="fa fa-search"></i>
                                                </b-btn>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="4">                            
                                            <b-input-group>
                                                <b-input-group-prepend><span class="p-2">Quantity</span></b-input-group-prepend>
                                                <b-form-input v-model="ordLinesObj.qtyOrder" type="number" v-b-tooltip.hover :title="`Qty: ${ordLinesObj.qtyOrder}`" :state="!$v.ordLinesObj.qtyOrder.$error" min="1"></b-form-input>
                                                <b-form-input v-model="ordLinesObj.unitsize" class="ml-1"></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                    </b-row >
                                    <b-input-group>
                                        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                                            <b-form-textarea :rows="2" :max-rows="3" v-model="ordLinesObj.description" :state="!$v.ordLinesObj.description.$error" maxlength="250" placeholder="Jenis/Posisi/Halaman/Chanel"></b-form-textarea>
                                        <b-form-checkbox id="chkPrint" class="ml-1 mt-2" v-model="ordLinesObj.printhide" value="1" unchecked-value="0" >No Print</b-form-checkbox>
                                    </b-input-group>
                                    <b-row no-gutters>
                                        <b-col md="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label >Price (Rate Card)</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                    <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                                                </b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="ordLinesObj.priceOrder" :precision="2" :state="!$v.ordLinesObj.priceOrder.$error"></my-number>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><span  class="p-2">Price Disc.</span></b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="ordLinesObj.priceDiscPc" :precision="0" v-b-tooltip.hover :title="ordLinesObj.priceDiscPc" style="padding-left:1px !important; padding-right:1px !important;"></my-number>
                                                <b-input-group-append><span class="ml-1 pt-2 mr-2"><i class="fa fa-percent"></i></span></b-input-group-append>
                                                <b-input-group-prepend><span class="input-group-text" style="width:55px;">{{model.matauang}}</span></b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="ordLinesObj.priceNett" :precision="2" style="width:33% !important;" v-b-tooltip.hover title="Saving Value"></my-number>
                                            </b-input-group>                                          
                                        </b-col>
                                    </b-row >   
                                    <b-row>
                                        <b-col md="5">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>PPN(VAT)</label></b-input-group-prepend>
                                                <b-form-checkbox id="chkPPN" class="ml-1 mt-2" v-model="ordLinesObj.kenappn" value=1 unchecked-value=0 @change="calcTaxes()" ></b-form-checkbox>
                                                <b-input-group-prepend ><span  class="pl-2 pt-2 pr-2 text-bold">Tarif</span></b-input-group-prepend>
                                                <b-form-input :disabled="(ordLinesObj.kenappn != 1)" v-model="ordLinesObj.ppn" @change="calcTaxes()" type="number" class="pr-0" v-b-tooltip.hover :title="ordLinesObj.ppn"></b-form-input>
                                                <b-input-group-append > <span class="input-group-text"><i class="fa fa-percent"></i></span></b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="7">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label style="width:200px !important;">Amt. Due to Customer</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                    <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                                                </b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="ordLinesObj.nilaidue" :precision="2" ></my-number>
                                            </b-input-group>
                                        </b-col>
                                    </b-row >   
                                    <b-row no-gutters>
                                        <b-col md="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label >Acc. Booked Sales</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                    <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                                                </b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="ordLinesObj.nettSales" :precision="2" ></my-number>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="6">  
                                                <b-form-checkbox id="chkNettSales" class="ml-1 mt-2" v-model="calcSales" value=1 unchecked-value=0>AUTO CALCULATE Acc. Booked Sales</b-form-checkbox>
                                        </b-col>
                                    </b-row >   
                                        <div v-if="(ordLinesObj.required_jadwal==1)" style="float:right;">
                                            <b-input-group >
                                                <b-input-group-append>
                                                    <b-button class="btn btn-success mr-1" @click="saveOrderLines()">Update</b-button>
                                                </b-input-group-append>
                                                <b-input-group-append>
                                                    <b-button class="btn btn-warning mr-2" @click="row.toggleDetails">Cancel</b-button>
                                                </b-input-group-append>
                                                <b-input-group-append><span class="pl-2 pt-2">Schedule</span></b-input-group-append>
                                                <b-input-group-append><span class="input-group-text">{{tgl_akan_muat.length}} Date(s)</span></b-input-group-append>
                                                <!-- <b-input-group-append v-if="tgl_akan_muat.length>0"> -->
                                                <b-input-group-append >
                                                    <b-btn text="Button" class="btn btn-danger ml-1" @click="clearJadwal">
                                                        <i class="fa fa-trash"></i> Clear Schedule
                                                    </b-btn>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </div>
                                </b-col>
                                <b-col lg="5">
                                    <b-row v-if="(ordLinesObj.required_jadwal==1)" class="justify-content-center mb-0" >
                                        <v-date-picker
                                            v-model="tgl_akan_muat"
                                            :columns="layout.columns"
                                            :rows="layout.rows"
                                            :is-expanded="layout.isExpanded"
                                            @dayclick="selectDate"
                                            mode="multiple"
                                            is-inline class="ml-5"
                                        />
                                    </b-row>
                                    <!-- <v-dim v-else :model="ordLinesObj" :key="updateDimDtl" ></v-dim>                                     -->

                                    <b-row class="justify-content-center mt-1" v-if="(ordLinesObj.required_jadwal==0)">
                                        <div style="width:400px;">
                                            <b-input-group >
                                                <!-- <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                                                <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox> -->
                                                <b-input-group-append>
                                                    <b-button class="btn btn-success mr-1" @click="saveOrderLines()">Update</b-button>
                                                </b-input-group-append>
                                                <b-input-group-append>
                                                    <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </div>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-card>
                    </template>
                    <template v-slot:cell(empty)="scope">
                        <h4>{{ scope.emptyText }}</h4>
                    </template>
                    <template v-slot:cell(emptyfiltered)="scope">
                        <h4>{{ scope.emptyFilteredText }}</h4>
                    </template>                        
                </b-table>
                 <b-row >
                    <b-col cols="4">
                        <b-row>
                        <b-button size="sm" class="ml-3" @click.stop="addOrderLines" >Add Order item</b-button>                          
                        <div class="ml-2">
                            Showing
                            {{(ordLines.page - 1) * ordLines.limit + 1}}
                            to
                            {{ordLines.page * ordLines.limit}}
                            <strong>
                            of
                            {{ordLines.total}}
                            entries </strong>
                        </div>    
                        </b-row>                    
                    </b-col>
                    <b-col cols="5">          
                    <b-input-group>
                        <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
                        <b-form-input v-model="ordLines.limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${ordLines.limit} records`" style="max-width:80px; !important;"></b-form-input>  
                        <b-pagination
                            :total-rows="ordLines.total"
                            :per-page="ordLines.limit"
                            v-model="ordLines.page"
                        ></b-pagination>
                    </b-input-group>
                    </b-col>
                    <b-col cols="3" >
                    <div class="text-right">
                        <b-input-group>
                            <b-input-group-prepend><span class="pt-2">Accounting Booked Sales</span></b-input-group-prepend>
                            <b-form-input :value="model.ttlSales | numFormat" readonly class="text-right" v-b-tooltip.hover title="Equal to Netto. Check!"></b-form-input>
                        </b-input-group>
                    </div>
                    </b-col>        
                </b-row>
            </b-card>    
            <b-row align-h="between" class="mt-1">
                <b-col lg="8">
                    <b-row no-gutters>
                        <b-col md="6">
                            <b-input-group >
                            <b-input-group-prepend><label>Bentuk Pembayaran</label></b-input-group-prepend>
                            <b-form-select v-model="model.jenisbayar" :options="paymentForms" :plain="true" class="mr-2">
                            </b-form-select>
                            </b-input-group>
                        </b-col>
                        <b-col md="6">
                                <b-form-input v-model="model.keteranganbayar" placeholder="Keterangan Pembayaran" class="ml-1"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Cara Pembayaran</label></b-input-group-prepend>
                                <b-form-radio-group inline class="p-1" v-model="model.iscash" >
                                    <b-form-radio value=0>Invoicing</b-form-radio>
                                    <b-form-radio value=1>Tunai(dibayar dimuka)</b-form-radio>
                                </b-form-radio-group>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6" v-if="(model.iscash!=1)">
                            <b-input-group v-if="(user.iklan==1)">
                                <b-input-group-prepend><span class="input-group-text">Tujuan Invoice</span></b-input-group-prepend>
                                <b-form-radio-group inline class="p-1" v-model="model.billtoadv" >
                                    <b-form-radio value=0>Agency</b-form-radio>
                                    <b-form-radio value=1>Advertiser</b-form-radio>
                                </b-form-radio-group>
                            </b-input-group>
                        </b-col>
                    </b-row>
    
                  <div class="bordered"></div>
                  <transition name="slide-fade">
                    <div v-if="(model.billtoadv==1)">
                      <b-input-group>
                        <b-input-group-prepend><label>Nama Advertiser</label></b-input-group-prepend>
                        <b-form-input v-model="model.advnama" placeholder="Nama Advertiser sesuai NPWP" style="width:40% !important;"></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">NPWP</span></b-input-group-prepend>
                        <b-form-input v-model="model.advnpwp" placeholder="NPWP"></b-form-input>
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend><label>Alamat Advertiser</label></b-input-group-prepend>
                        <b-form-input v-model="model.advaddr1" placeholder="Alamat 1"></b-form-input>
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend><label> </label></b-input-group-prepend>
                        <b-form-input v-model="model.advaddr2" placeholder="Alamat 2"></b-form-input>
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend><label>Telepon</label></b-input-group-prepend>
                        <b-form-input v-model="model.advtelp" placeholder="No Telepon"></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Fax</span></b-input-group-prepend>
                        <b-form-input v-model="model.advcity" placeholder="No. Fax"></b-form-input>
                      </b-input-group>
                    </div>
                  </transition>


                    <!-- <b-form-checkbox v-model="model.proforma" inline class="pt-1 ml-2"  value=1 unchecked-value=0>Invoicing FuLL diawal/sebelum iklan dimuat </b-form-checkbox> -->

                        <b-row v-if="(model.matauang !== uanguser)">
                            <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label >Exch. Rate <strong>{{model.matauang}}</strong></label></b-input-group-prepend>
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                                </b-input-group-prepend>
                                <my-number  class="form-control text-right" separator="," v-model="model.kursPPN" :state="!$v.model.kursPPN.$error"></my-number>
                            </b-input-group>
                            </b-col>
                            <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: right !important;">Kurs Pajak <strong>{{model.matauang}}</strong></label></b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{uanguser}}</span></b-input-group-prepend>
                                    <my-number class="form-control text-right" separator="," v-model="model.kursPPN"  :state="!$v.model.kursPPN.$error"></my-number>
                                </b-input-group>
                            </b-col>
                        </b-row>                      
                </b-col>
                <b-col lg="4">
                    <div class="text-right">
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Gross</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlgross" :precision="2" disabled></my-number>
                        </b-input-group>
                        <!-- <b-input-group >
                            <b-input-group-prepend>
                            <b-form-select style="width:158px;"  v-model="model.calcDisc" :plain="true" :options="calcuationDisc" ></b-form-select>
                            </b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttldiskon" :precision="2" :readonly="(model.calcDisc===1)"></my-number>
                        </b-input-group> -->
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Discount</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttldiskon" :precision="2" ></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Netto</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlnetto" :precision="2" disabled></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend>
                            <b-form-select style="width:158px;"  v-model="model.calcVAT" :plain="true" :options="calcuationVAT" ></b-form-select>
                            </b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlvat" :precision="2" :readonly="(model.calcVAT===1)"></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Total Amount Due</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlamtdue" :precision="2" disabled></my-number>
                        </b-input-group>
                    </div>
                </b-col>
            </b-row>

            <b-row class="justify-content-center mb-2">
                <div style="width:250px;">
                    <b-input-group >
                        <b-input-group-append>
                            <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                        </b-input-group-append>
                        <b-input-group-append>
                            <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </b-row>

        </b-card>

        <b-modal v-model="lkuSoShow" size="lg" :hide-footer="true" title="List of Sales Order"  :key="model.customer_id" :centered="true">
            <lku-salesorder @click="onSelectLkuSo" :customer="model.custinfo" :customer_id="model.customer_id" status='111'></lku-salesorder>
        </b-modal>        

        <b-modal v-model="lkuSalesShow" size="lg" :hide-footer="true" title="List of Sales Ex." :centered="true">
        <lku-salesae @click="onSelectsales"></lku-salesae>
        </b-modal>
        <b-modal v-model="lkuSalesCamapignShow" size="lg" :hide-footer="true" title="List of Campaign" :centered="true" >
        <lku-salescampaign @click="onSelectsalescamapign"></lku-salescampaign>
        </b-modal>
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Sales Items"  :centered="true">
            <lku-item @click="onSelectLkuItem" ></lku-item>
        </b-modal>        
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>        
      <b-modal v-model="showAttachment" header-bg-variant="primary"  title="PO/MO Attachment" size="lg" :centered="true" ok-only>
            <label>Add Attachment</label>
              <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>
              <b-row class="mt-1" >
                  <span class="p-2" >Selected file: <strong>{{ file ? file.name : '' }}</strong></span>   
              </b-row>
      </b-modal>

    </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required, decimal } from "vuelidate/lib/validators";
import myNumber from "../../components/my-number";
import lkuItem from "../lookup/lkuLookupSales";
import lkuCustomer from "../lookup/lkuCustomer";
import lkuSalescampaign from "../lookup/lkuSalesCampaign";
import lkuSalesae from "../lookup/lkuSalesae";
import lkuSalesorder from "../lookup/lkuSalesOrder";
import salesrevorder from "../../apis/salesrevorder";
import dimension from "../../apis/dimension";
toastr.init();

export default {   
    components: { myNumber, lkuItem, lkuCustomer,  lkuSalesae, lkuSalescampaign,lkuSalesorder},
    mixins: [validationMixin],
    validations: {
            model: {
                revisiondate: { required },
                revisionnote: { required },
                salesHdrKey: { required },
                OrderDate: { required },
                customer_id: { required },
                Advertiser: { required },
                brand: { required },
                kategori: { required },
                matauang: { required },
                ttlamtdue: { required },
                kursPPN: {required : (function() {
                    if ((this.model.ttlvat || 0) == 0) {
                        return true;
                    } else if ((this.model.kursPPN || 0) == 0){
                        return false;
                    } else return true;
                })},
            },
            ordLinesObj: {
                itemno: { required },
                description: { required },
                priceOrder: { required },
                remark: {required : (function() {
                    if ((this.ordLinesObj.qtyUndefined || 0) == 0) {
                        return true;
                    } else if ((this.ordLinesObj.remark || '')==''){
                        return false;
                    } else return true;
                })},
                qtyOrder: { required },
            },
    }, 
    data() {
        return {
            saveEnabled:true,
            inputBerlanjut: 0,
            inputLineBerlanjut: 0,
            lkuBrandShow: false,
            lkuCategoryShow: false,
            lkuItemShow:false,
            lkuSalesCamapignShow :false,
            lkuCustomerShow:false,
            lkuSalesShow:false,
            lkuSoShow: false,
            file:null,
            showAttachment:false,
            updateDimHdr:false,
            updateDimDtl:true,
            uanguser: this.$store.state.user.matauang,
            tarifPPN: this.$store.state.user.tarifppn || 10,
            user: this.$store.state.user,
            model: {
                OrderDate: '',
                customer_id: '',
                Advertiser: '',
                brand: '',
                kategori: '',
                matauang: this.$store.state.user.matauang, calcVAT:1, calcDisc:0, 
                nofaktur: '',
                tglfaktur: '',
                ttlamtdue: '',ttlSales:0, SalesEx:'', SalesExCode:'', salesae_id:'',
                kursPPN: 1,ttldiskon:0, iscash:0, billtoadv:0
            },
            ordLinesObj: {
                itemno:'', salesDtlKey:'',
                iteminfo: '',itemname : '',required_jadwal:0,
                remark: '',
                qtyOrder: 0,
                nettOrder: 0,nettSales:0,
                priceOrder:0,ppn:10,
                kenappn:1,printhide:0,discOrder:0,
                priceDiscPc:0,priceDisc:0,priceNett:0
            },
            tgl_akan_muat:[],      minDate: new Date(),
            calcuationVAT : [{ value: 1, text: 'VAT (Auto Calc)' }, { value: 0, text: 'VAT (Manual Calc)' }],
            calcuationDisc : [{ value: 1, text: 'Disc (Auto Calc)' }, { value: 0, text: 'Disc (Manual Calc)' }],
            calcPPh:1,calcSales:0,
            ordLines: {
                items: [],
                selected:{},
                fields: [
                    {key: 'index', label: 'No.' ,thStyle: "width:40px"},                    
                    {
                        key: "saleCrCode",
                        label: "Item Code",
                        thStyle: "width:100px",
                    },
                    {
                        key: "itemname",
                        label: "Item Name",
                    },
                    {
                        key: "description",
                        label: "Description",
                    },
                    {
                        key: "qtyOrder",
                        label: "Quantity",
                        thClass: "text-center",
                        tdClass: "text-center"
                    },
                    {
                        key: "priceOrder", 
                        label: "Price Order",
                        thStyle: "width:100px",
                        thClass: "text-right",
                        tdClass: "text-right"
                    },
                    {
                        key: "grossOrder", 
                        label: "Value Order",
                        thStyle: "width:110px",
                        thClass: "text-right",
                        tdClass: "text-right"
                    },
                    {
                        key: "discOrder", 
                        label: "Saving Value",
                        thStyle: "width:100px",
                        thClass: "text-right",
                        tdClass: "text-right"
                    },
                    {
                        key: "nettOrder", 
                        label: "Due/Nett",
                        thStyle: "width:110px",
                        thClass: "text-right",
                        tdClass: "text-right"
                    },
                    {
                        key: "action",
                        label: "Action",
                        thStyle: "width:40px",
                        thClass: "text-center",
                    },
                    {
                        key: "nettSales", 
                        label: "Acc. Booked Sales",
                        variant: "secondary",
                        thStyle: "width:110px",
                        thClass: "text-right",
                        tdClass: "text-right"
                    },
                ],
                page: 1,
                limit: 5,
                total: 0,
            },
            byae:0,
            paymentForms:[{value:'STANDARD', text: 'Standard Cash/Bank'}]
        };
    },
    computed: {
        dimension(){
            return this.$store.state.dimension;
        },
        invalidOrderLines() {
            this.$v.ordLinesObj.$touch();
            return this.$v.ordLinesObj.$invalid;
        },
        invalidModel() {
            this.$v.model.$touch();
            return this.$v.model.$invalid;
        },
        maxOrderDate(){
            return moment(new Date()).format('YYYY-MM-DD');
        },
        layout() {
        return this.$screens(
            {
            // Default layout for mobile
            default: {
                columns: 1,
                rows: 1,
                isExpanded: true,
            },
            // Override for large screens
            md: {
                columns: 2,
                rows: 1,
                isExpanded: false,
            },
            lg: {
                columns: 2,
                rows: 1,
                isExpanded: false,
            },
            },
        );
        },

    },
    created: async function(){
    const routeAsal = localStorage.getItem('SoRevMenu');
    if (routeAsal ==  "sales.revisionorderbyae") {
        this.byae=1;
    }

        if (this.$route.params.byae==1)  {
        console.log('masuk byae');
        this.byae=1;
        }
        if (this.$route.params.revisionkey)  {
            toastr.info('Loading Request Detail, please wait')
            try {
            const [f,data] = await Promise.all([salesrevorder.paymentform(),salesrevorder.detail(this.$route.params)]) ;
            // const data = await salesrevorder.detail(this.$route.params) ;
            this.paymentForms = f;
            
            const row = data[0];
            // this.dimension.forEach(dim => {
            //     if (row[`${dim.value}Txt`]) {
            //     row[`${dim.value}Info`] = row[`${dim.value}Txt`];
            //     }
            // });
            row.revisiondate = row.revisiondate ? moment(row.revisiondate).format('YYYY-MM-DD') : '';
            row.OrderDate = row.OrderDate ? moment(row.OrderDate).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            
            this.ordLines.items = data[1]
            this.ordLines.total=this.ordLines.items.length;
            this.calcTotalDtlOrder();
            // this.OrderDateBerubah();
            // this.updateDimHdr = !this.updateDimHdr;
            this.$forceUpdate();                
            toastr.clear;
            } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
            }
        } else {
            this.model.OrderDate = moment().format('YYYY-MM-DD');
            const [f] = await Promise.all([salesrevorder.paymentform()]) ;
            this.paymentForms = f;
        } 

  

        this.$watch('ordLinesObj.qtyOrder', function(newVal) {
            if (newVal==this.ordLinesObj.qtyOrder) {
                setTimeout(() => {
                    this.calcAmount();                    
                }, 100);
            }
        });            
        this.$watch('ordLinesObj.priceOrder', function(newVal) {
            if (newVal==this.ordLinesObj.priceOrder) {
                if (this.ordLinesObj.priceDiscPc) {
                    this.ordLinesObj.priceDisc = parseFloat((this.ordLinesObj.priceOrder || 0)) * parseFloat(this.ordLinesObj.priceDiscPc) / 100;        
                    this.ordLinesObj.priceNett = parseFloat(newVal) * (100-parseFloat(this.ordLinesObj.priceDiscPc ||0 )) / 100;        
                }
                setTimeout(() => {
                    this.calcAmount();                    
                }, 100);
            }
        });            
        this.$watch('ordLinesObj.priceDiscPc', function(newVal) {
            if (newVal==this.ordLinesObj.priceDiscPc) {
                this.ordLinesObj.priceDisc = parseFloat((this.ordLinesObj.priceOrder || 0)) * parseFloat(newVal) / 100;        
                this.ordLinesObj.priceNett = parseFloat((this.ordLinesObj.priceOrder || 0)) * (100-parseFloat(newVal ||0 )) / 100;   
                setTimeout(() => {
                    this.calcAmount();                    
                }, 100);
            }     
        });            
        this.$watch('ordLinesObj.priceDisc', function(newVal) {
            if (newVal==this.ordLinesObj.priceDisc) {
                this.ordLinesObj.priceNett = parseFloat((this.ordLinesObj.priceOrder || 0)) -parseFloat(newVal ||0 );        
                if (this.ordLinesObj.priceNett>0) {
                    this.ordLinesObj.printhide=0;
                } else {
                    this.ordLinesObj.printhide=1;
                }
                setTimeout(() => {
                    this.calcAmount();                    
                }, 100);
            }
        });            
        this.$watch('model.ttldiskon', function(newVal) {
            this.model.ttlnetto=this.model.ttlgross-this.model.ttldiskon;
            this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
        });            
        this.$watch('model.ttlvat', function(newVal) {
            this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
        });            
        this.$watch('calcSales', function(newVal) {
            if (newVal==1) {
                this.ordLinesObj.nettSales = this.ordLinesObj.nettOrder || this.ordLinesObj.grossOrder;
            }
        });            

    },
    methods: {
        closeOrderLines: function(){
            const opened= this.ordLines.items.find( r=> r._showDetails==true);
            if (opened) opened._showDetails=false;
        },
        addOrderLines : function () {
            this.closeOrderLines();
            const obj={_showDetails:true};
            this.ordLines.selected = obj;
            for (var key in this.ordLinesObj) {
                this.ordLinesObj[key] = '';
            }
            this.tgl_akan_muat=[];
            this.ordLinesObj.salesDtlKey=''
            this.ordLinesObj.unitsize='EACH';
            this.ordLinesObj.qtyOrder = 1;
            this.ordLinesObj.qtyUndefined = 0;
            this.ordLinesObj.nettOrder= 0;
            this.ordLinesObj.kenappn = 0;
            this.ordLinesObj.ppn = this.tarifPPN;
            this.ordLinesObj.priceDiscPc=0;
            this.ordLinesObj.printhide=0;
            this.ordLinesObj.nettSales= 0;
            this.ordLinesObj.itemname= '';
            this.ordLinesObj.required_jadwal= 0;
            this.updateDimHdr2Dtl(this.ordLinesObj);
            this.ordLines.items.push(obj);
            this.ordLines.total=this.ordLines.items.length;
            setTimeout(() => {
                const bfore = this.ordLines.page;
                const after =Math.ceil((this.ordLines.total)/this.ordLines.limit);
                if (bfore != after){
                    this.ordLines.page =  after;                 
                    toastr.info(`Move to page ${after} of total  ${this.ordLines.total} items`,'Line/Detail PR',10000);
                }
            }, 100);    
        },
        editOrderLines : function (obj,callback) {
            this.closeOrderLines();
            this.ordLines.selected = obj;
            // for (var key in this.ordLinesObj) {
            //     this.ordLinesObj[key] = '';
            // }
            this.dimension.forEach(dim => {
                if (obj[`${dim.value}Txt`]) {
                obj[`${dim.value}Info`] = obj[`${dim.value}Txt`];
                }
            });
            for (var key in obj) {
                this.ordLinesObj[key] = obj[key];
            }
            this.tgl_akan_muat=[];
            // if (obj.jadwal){
            //     this.tgl_akan_muat= JSON.parse(obj.jadwal);
            // }
            const arrJadwal=JSON.parse(obj.jadwal); 
            arrJadwal.forEach((jd,idx)=>{
            this.tgl_akan_muat.push(new Date(jd));
            });            
            this.ordLinesObj.typeseries = `${obj.itemcategory}`;
            this.dimension.forEach((dim) => {
                if (obj[dim.value]) {
                    this.ordLinesObj[dim.value] = obj[dim.value];
                    this.ordLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
                    this.ordLinesObj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
                }
            });
            callback();
        },
        delOrderLines: function (index) {
            if (index > -1) {
                // this.ordLines.items.splice(index, 1);
                const posisi = (this.ordLines.page-1)*this.ordLines.limit;
                this.ordLines.items.splice(posisi+index, 1);
            }
            this.ordLines.total=this.ordLines.items.length;
            this.calcTotalDtlOrder();
        },
        saveOrderLines: async function (callback) {
            this.calcAmount();
            if (this.invalidOrderLines) {
                console.log('validation : ', this.$v.ordLinesObj);
                console.log('model obj : ',this.ordLinesObj);
                toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
             } else {
                // console.log('this.ordLinesObj',this.ordLinesObj)
                let datadim=this.ordLinesObj;
                datadim.TableName = 'sales_order_line';
                try {
                    // const dimValResult = await dimension.validate(datadim);
                    // if (dimValResult.success) {
                        const arrJadwal= this.tgl_akan_muat.map(jd => moment(jd).format('YYYY-MM-DD'));        
                        this.ordLinesObj.jadwal= JSON.stringify(arrJadwal);
                        for (var key in this.ordLinesObj) {
                            this.ordLines.selected[key] = this.ordLinesObj[key];
                        }

                        if (this.calcSales==1) {
                            this.calcNettSales();
                        } else if ((this.ordLinesObj.grossOrder!=0) && (this.ordLinesObj.nettSales||0)==0) {
                            const pesan=`Acc.Booked Sales tidak diisi atau 0(NOL), Sistem akan menghitung Otomatis (AUTO CALCULATE)?`;
                            this.$bvModal.msgBoxConfirm(pesan, {
                            title: 'Please Confirm',
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'success',
                            okTitle: 'YES',
                            cancelTitle: 'NO',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true
                            })
                            .then(async(value) => {
                                if (value==true) {
                                    this.calcNettSales();
                                    setTimeout(() => {
                                        this.calcTotalDtlOrder();
                                    }, 300); 

                                }
                            })
                            .catch(err => {
                            // An error occurred
                            })  
                        }

                        this.dimension.forEach((dim) => {
                            if (datadim[dim.value]) {
                                this.ordLines.selected[dim.value] = datadim[dim.value];
                                this.ordLines.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
                            }
                        });
                        this.updateDimDtl2Hdr(datadim);
                        setTimeout(() => {
                            this.calcTotalDtlOrder();
                        }, 100); 
                        this.ordLines.selected._showDetails=false;
                        if (callback) callback();
                        if (this.inputLineBerlanjut==1) {
                            this.addOrderLines();
                            this.$v.ordLinesObj.$reset();
                        }

                    // } else {
                    //     var msg = dimValResult.message;
                    //     if (callback) callback(new Error(msg));
                    //     else {
                    //         toastr.error(msg, "ERROR MESSAGE",10000);
                    //     }
                    // }
                } catch (error) {
                    console.log('error : ', error);
                    if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }
                }
            }
        },
        save: async function () {
            if (!this.saveEnabled) {
                toastr.error('View mode cannot be Saved');
                return;
            }
            this.saveEnabled=false;
            this.calcTotalDtlOrder();
            if (this.invalidModel) {
                console.log('validation : ', this.$v.model);
                console.log('model obj : ',this.model);
                toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
                this.saveEnabled=true;
            } else if (Math.abs(this.model.ttlSales-this.model.ttlnetto)>0.5) {
                toastr.error('Accounting Booked Sales & Netto is not Balance ', 5000, "ERROR MESSAGE");
                this.saveEnabled=false;
            } else {
                try {
                    this.model.TableName = 'sales_order';
                    const dimValResult = await dimension.validate(this.model);
                    if (dimValResult.success) {
                        // this.model.DimTableKey = diisi dari PR/SR;
                        this.model.salesHdrKey = this.model.salesHdrKey || '';
                        this.model.nomor = this.model.nomor || '';
                        let lineno=0;
                        let diskonrkp=0;
                        const row = new FormData();
                        if (this.file){
                            row.append('file', this.file);
                            row.append('filename', this.file.name);
                        }
                        for (var key in this.model) {
                            row.append(key, this.model[key]);
                        }
                        row.set('revisiondate', moment(this.model.revisiondate).format('YYYY-MM-DD'));
                        row.set('OrderDate', moment(this.model.OrderDate).format('YYYY-MM-DD'));
                        const lines = this.ordLines.items.reduce((newArr, item) => {
                            if (((item.itemno || '') != '') && (item.qtyOrder != 0)) {
                                item.lineno = lineno+1;
                                item.valueIssued = this.ordLinesObj.invUnitCost * this.ordLinesObj.qtyOrder;
                                diskonrkp += item.priceDisc;    
                                newArr.push(item);
                                lineno += 1;
                            }
                            return newArr;
                        }, []);
                        row.set('diskonrkp',diskonrkp);
                        row.append(`lines`,JSON.stringify(lines));

                        if (lines.length>0) {
                            const hasil= await salesrevorder.save(row);
                            toastr.success(`Success, Trx.Number ${hasil.nomor}`, "Save Sales Order",10000);

                            if (this.inputBerlanjut==0){
                                this.close();
                            } else {
                                this.saveEnabled=true;            
                                for (var key in this.model) {
                                    this.model[key] = '';
                                }
                                this.model.matauang= this.$store.state.user.matauang;
                                this.model.tglpaym = moment().format('YYYY-MM-DD');
                                this.totalDtlPaym=0;
                                for (var key in this.ordLinesObj) {
                                    this.ordLinesObj[key] = '';
                                }
                                this.ordLines.items = [];
                                this.ordLines.total=0;
                                this.calcTotalDtlOrder();
                                this.$v.model.$reset();
                            }

                        } else {
                            toastr.error('Please fill at least 1(one) Order Detail', 'ERROR MESSAGE');
                            this.saveEnabled=true;
                        }
                    } else {
                        var msg = dimValResult.message || 'Dimension validation error';
                        toastr.error(msg, "ERROR MESSAGE");
                        this.saveEnabled=true;
                    }
                } catch (error) {
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
                    this.saveEnabled=true;            
                }
            }
        },
        
        onSelectLkuSo(_selected) {
            this.lkuSoShow=false;
            salesrevorder.detailsalesorder({salesHdrKey:_selected.salesHdrKey}).then(data=>{
                const row = data[0];
                console.log('row',row)
                row.OrderDate = row.OrderDate ? moment(row.OrderDate).format('YYYY-MM-DD') : '';
                for (var key in row) {
                    this.model[key] = row[key];
                }
                
                this.ordLines.items = data[1]
                this.ordLines.total=this.ordLines.items.length;
                this.calcTotalDtlOrder();

            }).catch(err => {
                console.log('get salesorder.detail -> ', err);
            });
        },    
        onSelectLkuBrand: async function (_selected) {
        this.model.brand = _selected.brandname;
        this.lkuBrandShow=false;
        },  
        onSelectLkuCategory: async function (_selected) {
        this.model.kategori = _selected.categoryname;
        this.lkuCategoryShow=false;
        },  
        onSelectLkuCustomer: async function (_selected) {
        this.model.custinfo = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
        this.model.customer_id = _selected.customer_id;
        this.model.Sell2Cust = _selected.CustCode.trim();
        this.lkuCustomerShow=false;
        },  
        onSelectLkuItem(_selected) {
            this.lkuItemShow=false;
            console.log('onSelectLkuItem ',_selected);
            this.ordLinesObj.itemname = _selected.NamaSale;
            this.ordLinesObj.iteminfo =_selected.saleCrCode.trim() + " | " + _selected.NamaSale.trim();
            this.ordLinesObj.saleCrCode = _selected.saleCrCode;
            this.ordLinesObj.itemno = _selected.kode;
            this.ordLinesObj.required_jadwal  = _selected.required_jadwal;
            if (_selected.iklandigital==1) {
                this.ordLinesObj.unitsize='SPOT';
            }
            if (_selected.iklancetak==1) {
                this.ordLinesObj.unitsize='TAYANG';
            }
            this.calcAmount();
            console.log('this.ordLinesObj: ',this.ordLinesObj);
        },
        onSelectsales(_selected) {
        this.model.SalesEx = `${_selected.salesae_name} ${" | "+_selected.crewnik} `;
        // this.model.SalesExCode = _selected.crewkey;
        this.model.SalesExCode = _selected.salesae_id;
        this.model.salesae_id = _selected.salesae_id;
        this.lkuSalesShow = false;
        },
        onSelectsalescamapign(_selected) {
        this.model.campaign = `${_selected.uraian}`;
        this.model.CampaignKey = _selected.campaignKey;
        this.lkuSalesCamapignShow = false;
        },

        updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
        },
        updateDimHdr2Dtl: function (dimDtl) {
            var dimHdr = this.model;
            dimDtl = dimDtl || this.ordLinesObj;
            this.dimension.forEach((dim) => {
                if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                    dimDtl[dim.value] = dimHdr[dim.value];
                    dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                    dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
                }
            });
            this.updateDimDtl = !this.updateDimDtl;
        },
        selectDate(val) {
            const date = moment(val.date).format('YYYY-MM-DD');
            const index = this.tgl_akan_muat.findIndex(tgl => moment(tgl).format('YYYY-MM-DD') === date);      
            if (index > -1) {
                this.tgl_akan_muat.splice(index, 1);
            } else {
                this.tgl_akan_muat.push(new Date(date));
            }
        },
        clearJadwal: function(){
            this.tgl_akan_muat=[];
        },
        calcAmount : function() {
            this.ordLinesObj.grossOrder = parseFloat(this.ordLinesObj.priceOrder || 0) * parseFloat(this.ordLinesObj.qtyOrder || 0);
            this.ordLinesObj.discOrder = parseFloat(this.ordLinesObj.priceDisc  || 0) * parseFloat((this.ordLinesObj.qtyOrder || 0));        
            this.ordLinesObj.nettOrder = this.ordLinesObj.grossOrder -this.ordLinesObj.discOrder;
            if (this.calcSales==1) {
                this.ordLinesObj.nettSales = this.ordLinesObj.nettOrder || this.ordLinesObj.grossOrder;
            // } else {
            //     if (!(this.ordLinesObj.nettSales)) this.ordLinesObj.nettSales = this.ordLinesObj.nettOrder || this.ordLinesObj.grossOrder;
            }
            this.calcTaxes();
        },
        calcNettSales: function(){
            const sortLines = this.ordLines.items.sort(function(a, b){return b.nettOrder - a.nettOrder});
            const tertinggi = sortLines[0];
            if ((tertinggi.nettOrder || 0)>0) {
                const idxTertinggi = this.ordLines.items.findIndex(l => ((l.nettOrder==tertinggi.nettOrder) && (l.itemno==tertinggi.itemno)));
                this.ordLines.items[idxTertinggi].nettSales = this.ordLines.items[idxTertinggi].nettOrder;
                this.ordLines.items.forEach((l,idx)=>{
                    if (idxTertinggi!=idx){
                        // if ((l.grossOrder!=0) && (l.nettOrder==0)) {
                            l.nettSales = l.grossOrder;
                            this.ordLines.items[idxTertinggi].nettSales-= l.discOrder; 
                        // }
                    } 
                });
            }
        },
        calcTaxes : function() {
            // this.ordLinesObj.nettOrder = parseFloat(this.ordLinesObj.grossOrder || 0) - parseFloat(this.ordLinesObj.priceDisc || 0);
            this.ordLinesObj.dpp = parseFloat(this.ordLinesObj.nettOrder  || 0);
            // if (this.ordLinesObj.kenappn == 1) {
            //     this.model.grossup = 0;
            //     this.ordLinesObj.ppn = this.tarifPPN;
            // } else {
            //     this.ordLinesObj.dpp = 0;
            //     this.ordLinesObj.ppn = 0;
            // }
            this.ordLinesObj.nilaippn = 0;
            if (this.ordLinesObj.kenappn == 1) {
                this.ordLinesObj.nilaippn = (parseFloat(this.ordLinesObj.ppn)/100) * this.ordLinesObj.dpp;;
            }

            this.ordLinesObj.nilaidue = parseFloat(this.ordLinesObj.nettOrder) + this.ordLinesObj.nilaippn;
            this.$forceUpdate();
        },
        calcTotalDtlOrder: function () {
            this.model.calcVAT = this.model.calcVAT || 1;
            this.model.calcDisc = this.model.calcDisc || 0;
            let nilaidpp = 0;
            let ttlvat = 0;
            let ttlgross = 0;
            let ttlSales = 0;
            // let totaldpp = 0;
            this.ordLines.items.forEach((trx)=> {
                if (trx.itemno) {
                    nilaidpp += (trx.dpp || 0);
                    ttlgross += (trx.nettOrder || 0);
                    // ttldiskon += (trx.discOrder  || 0);
                    ttlvat += (trx.nilaippn || 0);
                    ttlSales += (trx.nettSales || 0);
                }
            });
            this.model.ttlSales = ttlSales;
            this.model.nilaidpp = nilaidpp;
            this.model.ttlgross = ttlgross;
            if (this.model.calcVAT == 1){
                this.model.ttlvat = ttlvat;
            }
            // if (this.model.calcDisc == 1){
            //     this.model.ttldiskon = ttldiskon;
            // }
            this.model.ttlnetto =this.model.ttlgross-this.model.ttldiskon;
            this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
        },
        close(){
           if (this.byae==1) {
             router.push({path: "revision-order-byae/1"});
           } else {
            router.push({name:'sales.revisionorder'});
           }           

        }
    }
};
</script>
